export default __webpack_public_path__ + "static/greenday-612348988f7622769a168573e5825930.png";